import React, { Fragment } from "react";
import HomeComponent from "../component/app/home/Home.component";
import { useAuth } from "../context/Auth.context";
import TransactionsComponent from "../component/app/admin/transactionHistory/Transactions.component";

const TransactionPage = () => {
  const auth = useAuth();

  return (
    <Fragment>
      {auth?.user?.loggedInAs === "admin" ? (
        <TransactionsComponent />
      ) : (
        <HomeComponent />
      )}
    </Fragment>
  );
};

export default TransactionPage;
